import { UATConstants } from 'src/Common/Models/UATConstants';
import { ITenantUIConfig, TenantProvider } from 'src/tenantConfig/interface/index.ts';
import { nonAiCapacityIntakeFilterConfig } from 'src/tenantConfig/filters/NonAiCapacityIntake';
export const nonAiCapacityIntakeConfig: Partial<ITenantUIConfig> = {
  nodeName: [UATConstants.PlaceholdersAndTitles.NonAICapacityNodeName], //NonAI Capacity
  provider: TenantProvider.ADO,
  TenantExperience: true,
  FeatureConfig: {
    SensitiveInfoValidation: true,
    SensativeInfoErrorCount: false,
    AttachmentConfigurations: [],
    Navigation: {
      GlobalSearch: true,
      Copilot: true,
      Analytics: false,
      RequestAccess: true,
      Settings: true,
      Notifications: true,
      Help: true,
    },
    Hub: {
      Filter: true,
      FilterConfig: nonAiCapacityIntakeFilterConfig,
      AreaPath: [UATConstants.NonAICapacityAreaPath],
      Title: UATConstants.TenantTitles.NonAICapacity,
      ADOTitle: UATConstants.TenantADOText.NonAICapacity,
      Create: [],
      hideCreateButton: true,
      BulkUpload: false,
      DownloadTemplate: false,
      Download: true,
      Email: true,
      LocalSearch: true,
      ColumnOptions: true,
      ColumnOptionsConfig: [],
      SplitMode: true,
      BulkEdit: false,
      BulkEditConfig: [],
      CreateRAID: false,
      DownloadTemplateConfig: {
        tenantToolName: 'rob',
        title: UATConstants.PlaceholdersAndTitles.AOAITitle,
        excelColumnSequence: {
          'Title': 1,
          'Action Owner': 2,
          'Assigned Team': 3,
          'AOAI_Amount': 4,
          'AOAI_ApprovedPreferredRegion': 5,
          'AOAI_AzureCapacityType': 6,
          'AOAI_AzurePreferredRegion': 7,
          'AOAI_DateCustomerReady': 8,
          'AOAI_DateDecided': 9,
          'AOAI_Decision': 10,
          'AOAI_IsAmendmentM1072Signed?': 11,
          'AOAI_Model': 12,
          'AOAI_PreferredRegion': 13,
          'AOAI_QuotaID': 14,
          'AOAI_RequestedAmount': 15,
          'AOAI_RequestType': 16,
          'AOAI_SegmentType': 17,
          'AOAI_SubscriptionID': 18,
          'AOAI_Timezone': 19,
        },
      },
    },
    ManageAction: {
      NewExperience: true,
      MandateFormPickers: [
        { formFieldName: 'assignedTo', apiFieldName: 'assignedTo' },
        { formFieldName: 'requestor', apiFieldName: 'requestor' },
      ],
      Header: {
        Tags: true,
        Actions: {
          Follow: false,
          Email: false,
          CopyLink: false,
        },
      },
      Tabs: {
        TechnicalFeedback: false,
        RelatedItems: {
          showRelatedTab: true,
          showTFTCreated: true,
        },
        Attachments: true,
        History: true,
      },
      Panes: {
        CopilotInsights: {
          CustomerInsights: false,
          DiscussionInsights: false,
        },
        StatusUpdate: false,
        ClosureStatement: false,
        Discussion: false,
        Tasks: false,
        EmailConversation: false,
      },
    },
    ManageView: {
      isFieldConfigurationEnabled: true,
      showAddViewButton: true,
      showAddFolderButton: false,
      isArtemisIntegrationEnabled: true,
      showCommandBar: true,
      showPreviewFeatureMessageBar: false,
      showSelectFields: false,
    },
  },
};
